import React from 'react'
import { Player, BigPlayButton } from 'video-react';
// import GifPlayer from 'react-gif-player'
import * as typeformEmbed from '@typeform/embed'

export default class Hero extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render() {
    const { bannerTitle, bannerDesc, bannerDescHighLight, bannerImage, bannerVideo, showVideo, bannerGif, buttonText, buttonUrl } = this.props
    let typeForm
    if (process && process.browser) {
      typeForm = typeformEmbed.makePopup(
        buttonUrl,
        {
          opacity: 55,
          buttonText: "Request Invite",
          hideScrollbars: true,
          onSubmit: function () {
            setTimeout(() => typeForm.close(), 2000)
          }
        }
      )
    }
    return (
      <>
        <div className="jumbotron jumbotron-fluid bg-primary fw-500 mb-0 section-bg banner-hero">
          <div className="sm-space"></div>
          <div className="container">
            <div className="row align-items-center gif">
              <div className="col-12 col-lg-8 mx-lg-auto">
                <div className="text-center">
                  <h1 className="xxl-font fw-700 bannerTitle">
                    {bannerTitle}
                  </h1>
                </div>
              </div>
              <div className="col-12 col-lg-8 mx-lg-auto">
                <div className="text-center">
                  <div className="fluid-paragraph fluid-paragraph-xl text-center bannerDesc">
                    {/* <p className="mb-0">{bannerDesc}</p> */}
                    <div className="sm-space"></div>
                    <p className="mb-0"><span className="fw-600">{bannerDescHighLight}</span> {bannerDesc}</p>
                  </div>
                  <div className="md-space"></div>
                  <div className="row">
                    <div className="col-12 col-md-6 mx-auto">
                      {/* eslint-disable-next-line  */}
                      <a
                        href="#"
                        onClick={() => {
                          process && process.browser &&
                            typeForm.open()
                        }}
                        className="btn mb-2 sm-font pirlo-btn">
                        {buttonText ? buttonText : "Request Invite"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-12 mx-auto">
                <div className="md-space"></div>
                <hr />
                <div className="md-space"></div>
              </div>
              <div className="col-12 col-md-11 mx-auto benefits">
                <div>
                  <img src="/img/verified.png" alt="No code test creation" /> No code test creation
                </div>
                <div>
                  <img src="/img/verified.png" alt="Less effort for test maintenance" /> Less effort for test maintenance
                </div>
                <div>
                  <img src="/img/verified.png" alt="Detect bugs during development" /> Detect bugs during development
                </div>
              </div>
              <div className="col-12 col-md-10 mx-auto">
                <div className="xlg-space"></div>
                <div className="row align-items-center">
                  <div className="col-md-12 col-xs-12 justify-content-center">
                    <div className="text-center gif-div">
                      {
                        showVideo ?
                          <Player poster={bannerImage} src={bannerVideo}>
                            <BigPlayButton position="center" />
                          </Player>
                          :
                          // <GifPlayer gif={bannerGif} still={bannerImage} />
                          <img
                            src={bannerGif}
                            className="w-100"
                            alt={bannerTitle}
                            title={bannerTitle}
                          />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="gif-space">
        </div>
      </>
    )
  }
}
